import React from "react";
import styled from "styled-components";
import InfiniteScroll from "react-infinite-scroll-component";
import { WhiteWrapper } from "../Common/styles.common";
import { GrnCard } from "./GrnCard";
import { Loader } from "../Common/Loader";
import {
  CrossIconWrapper,
  FilterChip,
  FiltersRow,
  GrnPageWrapper,
  SearchBar,
  SearchBarContainer,
  SearchIcon,
  SearchToggleButton,
  SearchToggleIcon,
} from "./styles.grn";
import { strings } from "utils/constants/strings";
import BackButton from "../Button/BackButton";
import ShowToast from "../Common/Toast";
import Cross from "sushiweb/Icons/all/Cross";
import { GRN_OR_FILTERS } from "./utils";

// The list is a fixed full-screen layout; anchor it to the viewport so it still
// covers the app header that BasePageView renders above mobile views.
const MobilePageWrapper = styled(GrnPageWrapper)`
  top: 0;
  left: 0;
`;

const GrnListMobile = ({
  poGrnMappings,
  orFilters,
  isSearchOpen,
  searchString,
  setSearchString,
  toggleFilter,
  handleSearchToggle,
  hasMore,
  loadNextPage,
  isListLoading,
  isEmpty,
  showToast,
}) => {
  const cards = Array.isArray(poGrnMappings)
    ? poGrnMappings.map((grn, index) => <GrnCard key={index} grn={grn} source={"list"} />)
    : [];

  return (
    <React.Fragment>
      <MobilePageWrapper className="d-flex flex-column">
        <WhiteWrapper>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <BackButton pathName={"/"} />
              <span className="fs-16 fw-600">{strings.grnListMobileTitle}</span>
            </div>
            <SearchToggleButton onClick={handleSearchToggle} aria-label="Toggle search">
              <SearchToggleIcon src="/logos/search-basic.svg" alt="search" />
            </SearchToggleButton>
          </div>
          {isSearchOpen ? (
            <div className="mt-4">
              <SearchBarContainer>
                <SearchIcon src="/logos/search-basic.svg" alt="search" />
                <SearchBar
                  type="text"
                  placeholder={strings.searchGRNList}
                  value={searchString}
                  onChange={(event) => setSearchString(event.target.value)}
                />
              </SearchBarContainer>
            </div>
          ) : null}
        </WhiteWrapper>
        <FiltersRow>
          {GRN_OR_FILTERS.map((filter) => {
            const isSelected = orFilters.includes(filter.value);

            return (
              <FilterChip
                key={filter.value}
                $selected={isSelected}
                onClick={() => toggleFilter(filter.value)}
                type="button"
              >
                <span className="fs-13">{filter.label}</span>
                {isSelected ? (
                  <CrossIconWrapper
                    onClick={(event) => {
                      event.stopPropagation();
                      toggleFilter(filter.value);
                    }}
                  >
                    <Cross color="#293142" height={16} width={16} />
                  </CrossIconWrapper>
                ) : null}
              </FilterChip>
            );
          })}
        </FiltersRow>
        {isListLoading ? (
          <div className="mt-4">
            <Loader isScrollLoader={true} />
          </div>
        ) : isEmpty ? (
          <div className="d-flex justify-content-center mt-6">
            <span className="fs-14 fw-400 text-gray-cool">{strings.noGrnsFound}</span>
          </div>
        ) : (
          <InfiniteScroll
            className="infinite-scroll"
            height={"87%"}
            dataLength={cards.length}
            hasMore={hasMore}
            next={loadNextPage}
            loader={<Loader isScrollLoader={true} />}
          >
            {cards}
          </InfiniteScroll>
        )}
      </MobilePageWrapper>
      {showToast ? <ShowToast /> : <></>}
    </React.Fragment>
  );
};

export default GrnListMobile;
